<app-benefits-list
  [benefitsListItems]="benefitsListAdditionalItems()"
  [iconTemplate]="iconTemplateAdditionalItems"
  [title]="title()"
>
  <ng-template #iconTemplateAdditionalItems let-icon="iconName">
    <div class="benefits-list-items-additional-items__icon-container">
      <app-icon
        [name]="icon"
        [size]="'sm'"
        class="benefits-list-items-additional-items__icon"
      />
    </div>
  </ng-template>
</app-benefits-list>
